import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ISettings {
  usingLang: string;
  ifHyperlink: boolean;
  isIframeAllowed: boolean;
}

const initialState: ISettings = {
  usingLang: "en",
  ifHyperlink: false,
  isIframeAllowed: false,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setUsingLang: (state, action: PayloadAction<string>) => {
      state.usingLang = action.payload;
    },
    setIfHyperlink: (state, action: PayloadAction<boolean>) => {
      state.ifHyperlink = action.payload;
    },
    setIsIframeAllowed: (state, action: PayloadAction<boolean>) => {
      state.isIframeAllowed = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUsingLang, setIfHyperlink, setIsIframeAllowed } =
  settingsSlice.actions;

export default settingsSlice.reducer;
